/**
 * Leere HTML Tags löschen
 *
 * Leere HTML Tags werden entfernt und nicht mehr ausgegeben. Hierzu zählen alle Elemente die vollständig leer sind, nur
 * Leerzeichen, Tabs oder sonstige Einrückungen enthalten.
 *
 * Events: document.ready
 *
 * @param {string} selectorOuter - Umschließendes Element, welches ausgelesen wird
 * @param {string} selectorInner - Kind des umschließenden Elements, welches ausgelesen wird
 *
 * @return {undefined}
 */
function nc_initRemoveEmptyTags(selectorOuter, selectorInner) {
    var moduleLogger = LoggerManager.get('remove-empty-tags').setPrefix('SelektorOuter: ' + selectorOuter +'; SelektorInner: ' + selectorInner);
    moduleLogger.trace('INIT START');
    $(document).ready(function () {
        nc_removeEmptyTags(selectorOuter, selectorInner);
    });
    moduleLogger.info('INIT ENDE');
}


/**
 * @see nc_initRemoveEmptyTags
 */
function nc_removeEmptyTags(selectorOuter, selectorInner) {
    var moduleLogger = LoggerManager.get('remove-empty-tags').setPrefix('SelektorOuter: ' + selectorOuter +'; SelektorInner: ' + selectorInner);
    moduleLogger.trace('SCRIPT START');
    // Finde im selectorOuter den selectorInner. Wenn kein Inhalt vorhanden, dann entferne das Element
    $(selectorOuter).each(function () {
        if (!$.trim($(this).find(selectorInner).html()).length) {
            moduleLogger.info('Leerer Tag entfernt', $(this));
            $(this).remove();
        }
    });
    moduleLogger.info('SCRIPT ENDE');
}